import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, FormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormArray, FormGroup } from '@angular/forms';
import moment, { Moment } from 'moment';
import { Subscription, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiHttpService } from 'src/app/services/api-http.service';
import { DataService } from 'src/app/services/data.service';
import { debugForm, setRequired } from 'src/app/shared/utils';
import { categorieUso, settoriMerceologici, potenzeImpegnate, richiesteList } from 'src/app/shared/utils';
import { BWAsyncValidator } from 'src/app/shared/validators/validators';

@Component({
  selector: 'app-dati-fornitura',
  templateUrl: './dati-fornitura.component.html',
  styleUrls: ['./dati-fornitura.component.scss']
})
export class DatiFornituraComponent implements OnInit {

  @Input() datiAnaForm!: UntypedFormGroup;
  @Input() datiFirmaForm!: UntypedFormGroup;
  disableFirmaVolture: boolean = false;

  datiFornForm: UntypedFormGroup;
  setRequired = setRequired;
  altriDatiPanel = false;

  distributoriEE?: any[];
  distributoriGAS?: any[];
  distributoriEE$?: Subscription;
  distributoriGAS$?: Subscription;

  altriDatiTecnici = {
    show: false,
    livelloTensione: false,
    tensione: false,
    potenzaImpegnata: false,
    potenzaDisponibile: false,
    volume: false,
    presenzaCliente: false,
    dataDecorrenza: false,
    distributoreEE: false,
    distributoreGAS: false,
    categoriaUso: false,
    potenzaMassimaRichiesta: false,
    consumoAnnuo: false,
    tipoSubentro: false,
    dataFineFornitura: false,
    ctrTempoDeterminato: false,
    settoreMerceologico: false,
    tipoVoltura: false,
    lettura: false
  }

  tipiVolture = [
    { value: '01', label: 'Voltura Ordinaria' },
    { value: '02', label: 'Voltura Mortis Causa' },
    { value: '03', label: 'Incorporazione societaria' },
    { value: '04', label: 'Voltura in continuità' },
    { value: '05', label: 'Recupero' }
  ]


  pods(richiesta: any) {
    return richiesta.get('pods') as UntypedFormArray;
  }
  pdrs(richiesta: any) {
    return richiesta.get('pdrs') as UntypedFormArray;
  }

  get prodotto() {
    return this.dataService.prodotto;
  }

  get richieste() {
    return this.datiFornForm.get('richieste') as UntypedFormArray;
  }

  get richiesteListFiltered() {
    return richiesteList.filter(el => el.show);
  }
  get categorieUsoFiltered() {
    return categorieUso.filter(el => el.tipo_utenza.includes(this.prodotto!.tipo_utenza));
  }

  get _potenzeImpegnate() {
    return potenzeImpegnate;
  }

  // get _settoriMerceologici() {
  //   settoriMerceologici.sort((a, b) => {
  //     let _a = a.code.split('.');
  //     let _b = b.code.split('.');

  //     if (_a[0] == _b[0]) {
  //       if (_a[1] == _b[1]) {
  //         return this.compareValues(_a[2], _b[2]);
  //       } else {
  //         return this.compareValues(_a[1], _b[1]);
  //       }
  //     } else {
  //       return this.compareValues(_a[0], _b[0]);
  //     }

  //   })
  //   return settoriMerceologici;
  // }

  _settoriMerceologici = of(settoriMerceologici);

  compareValues(a: string, b: string) {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    }
    else {
      return 0;
    }
  }

  secondLineFn(item: any) {
    return `${item.description}`;
  }

  getRichiesta(ri: any): UntypedFormGroup {
    return this.richieste.at(ri) as UntypedFormGroup;
  }

  indirizzoForm(punto: any) {
    return (punto.get('indirizzo') as UntypedFormGroup);
  }

  secondLineDistributore(item: any) {
    return `${item.comune} (${item.provincia}) - ${item.regione}`;
  }

  get tipoUtenza() {
    return this.prodotto?.tipo_utenza;
  }

  get richiestaGroup() {
    let _group = new UntypedFormGroup({
      richiesta: new UntypedFormControl(null, [Validators.required]),
      commodity: new UntypedFormControl(null, [Validators.required]),
      pods: new UntypedFormArray([]),
      pdrs: new UntypedFormArray([]),
    })

    if (this.tipoUtenza == 'BUS') {
      this.altriDatiTecnici.settoreMerceologico = true;
    };


    if (this.prodotto?.cod_tipo_fornitura_id == 'EE') {
      _group.get('richiesta')?.valueChanges.subscribe(value => {
        this.altriDatiTecnici.show = false;
        this.altriDatiTecnici.tipoVoltura = false;
        this.altriDatiTecnici.dataDecorrenza = false;
        this.altriDatiTecnici.distributoreEE = false;
        this.altriDatiTecnici.tensione = false;
        this.altriDatiTecnici.potenzaImpegnata = false;
        this.altriDatiTecnici.potenzaDisponibile = false;
        this.altriDatiTecnici.presenzaCliente = false;
        this.altriDatiTecnici.livelloTensione = false;
        this.altriDatiTecnici.volume = false;

        if (value == 'S01' || value == 'A01') {
          this.altriDatiTecnici.show = true;
          this.altriDatiTecnici.livelloTensione = true;
          this.altriDatiTecnici.tensione = true;
          this.altriDatiTecnici.potenzaImpegnata = true;
          this.altriDatiTecnici.potenzaDisponibile = true;
          this.altriDatiTecnici.volume = true;
          this.altriDatiTecnici.presenzaCliente = true;
        } else if (value == 'N02') {
          this.altriDatiTecnici.show = true;
          this.altriDatiTecnici.livelloTensione = true;
          this.altriDatiTecnici.tensione = true;
          this.altriDatiTecnici.potenzaImpegnata = true;
          this.altriDatiTecnici.potenzaDisponibile = true;
          this.altriDatiTecnici.volume = true;
          this.altriDatiTecnici.presenzaCliente = true;
          this.altriDatiTecnici.distributoreEE = true;
        } else if (value == 'SE1' || value == 'AOF' || value == 'VT1' || value == 'VL1') {
          if (this.tipoUtenza == 'BUS') {
            this.altriDatiTecnici.show = true;
            this.altriDatiTecnici.livelloTensione = true;
            this.altriDatiTecnici.volume = true;

            if (this.dataService.user == 3 && (value == 'SE1' || value == 'AOF')) {
              this.altriDatiTecnici.dataDecorrenza = true;
            }

            if (value == 'VT1' || value == 'VL1') {
              this.altriDatiTecnici.tipoVoltura = true;
            }
          } else {
            if (value == 'VT1' || value == 'VL1') {
              this.altriDatiTecnici.show = true;
              this.altriDatiTecnici.tipoVoltura = true;
            }
          }
        }
      })
    } else if (this.prodotto?.cod_tipo_fornitura_id == 'GAS') {
      _group.get('richiesta')?.valueChanges.subscribe(value => {
        this.altriDatiTecnici.show = false;
        this.altriDatiTecnici.tipoVoltura = false;
        this.altriDatiTecnici.lettura = false;
        this.altriDatiTecnici.tipoSubentro = false;
        this.altriDatiTecnici.distributoreGAS = false;
        this.altriDatiTecnici.categoriaUso = false;
        this.altriDatiTecnici.potenzaMassimaRichiesta = false;
        this.altriDatiTecnici.dataDecorrenza = false;

        // if (value == 'S01' || value == 'A01') {
        if (value == 'S01') {
          this.altriDatiTecnici.show = true;
          this.altriDatiTecnici.distributoreGAS = true;
          this.altriDatiTecnici.categoriaUso = true;
          this.altriDatiTecnici.potenzaMassimaRichiesta = true;
          this.altriDatiTecnici.consumoAnnuo = true;
          this.altriDatiTecnici.tipoSubentro = true;
        } else if (value == 'N02') {
          this.altriDatiTecnici.show = true;
          this.altriDatiTecnici.distributoreGAS = true;
          this.altriDatiTecnici.categoriaUso = true;
          this.altriDatiTecnici.potenzaMassimaRichiesta = true;
          this.altriDatiTecnici.consumoAnnuo = true;
        } else if (value == 'SE1' || value == 'AOF' || value == 'VT1' || value == 'VL1') {
          // if (this.tipoUtenza == 'BUS') {
          this.altriDatiTecnici.show = true;
          this.altriDatiTecnici.consumoAnnuo = true;
          // }

          if (this.dataService.user == 3 && value == 'AOF') {
            this.altriDatiTecnici.dataDecorrenza = true;
          }

          if (value == 'VT1' || value == 'VL1') {
            this.altriDatiTecnici.tipoVoltura = true;
            this.altriDatiTecnici.lettura = true;
          }
        }
      })
    } else if (this.prodotto?.cod_tipo_fornitura_id == 'EE/GAS') {
      _group.get('richiesta')?.valueChanges.subscribe(value => {
        this.altriDatiTecnici.tipoVoltura = false;
        this.altriDatiTecnici.lettura = false;
        // if (value == 'S01' || value == 'A01') {
        if (value == 'S01') {
          this.altriDatiTecnici.show = true;
          this.altriDatiTecnici.livelloTensione = true;
          this.altriDatiTecnici.tensione = true;
          this.altriDatiTecnici.potenzaImpegnata = true;
          this.altriDatiTecnici.potenzaDisponibile = true;
          this.altriDatiTecnici.volume = true;
          this.altriDatiTecnici.presenzaCliente = true;
          this.altriDatiTecnici.dataDecorrenza = false;

          this.altriDatiTecnici.distributoreEE = false;
          this.altriDatiTecnici.distributoreGAS = true;
          this.altriDatiTecnici.categoriaUso = true;
          this.altriDatiTecnici.potenzaMassimaRichiesta = true;
          this.altriDatiTecnici.consumoAnnuo = true;
          this.altriDatiTecnici.tipoSubentro = true;

        } else if (value == 'N02') {
          this.altriDatiTecnici.show = true;
          this.altriDatiTecnici.livelloTensione = true;
          this.altriDatiTecnici.tensione = true;
          this.altriDatiTecnici.potenzaImpegnata = true;
          this.altriDatiTecnici.potenzaDisponibile = true;
          this.altriDatiTecnici.volume = true;
          this.altriDatiTecnici.presenzaCliente = true;
          this.altriDatiTecnici.dataDecorrenza = false;

          this.altriDatiTecnici.distributoreEE = true;
          this.altriDatiTecnici.distributoreGAS = true;
          this.altriDatiTecnici.categoriaUso = true;
          this.altriDatiTecnici.potenzaMassimaRichiesta = true;
          this.altriDatiTecnici.consumoAnnuo = true;
          this.altriDatiTecnici.tipoSubentro = false;

        } else if (value == 'SE1' || value == 'AOF' || value == 'VT1' || value == 'VL1') {
          this.altriDatiTecnici.distributoreEE = false;
          this.altriDatiTecnici.distributoreGAS = false;
          this.altriDatiTecnici.categoriaUso = false;
          this.altriDatiTecnici.potenzaMassimaRichiesta = false;
          this.altriDatiTecnici.consumoAnnuo = false;
          this.altriDatiTecnici.tipoSubentro = false;

          if (this.tipoUtenza == 'BUS') {
            this.altriDatiTecnici.show = true;
            this.altriDatiTecnici.livelloTensione = true;
            this.altriDatiTecnici.tensione = false;
            this.altriDatiTecnici.potenzaImpegnata = false;
            this.altriDatiTecnici.potenzaDisponibile = false;
            this.altriDatiTecnici.volume = true;
            this.altriDatiTecnici.presenzaCliente = false;
            if (this.dataService.user == 3 && (value == 'SE1' || value == 'AOF')) {
              this.altriDatiTecnici.dataDecorrenza = true;
            } else {
              this.altriDatiTecnici.dataDecorrenza = false;
            }

            if (value == 'VT1' || value == 'VL1') {
              this.altriDatiTecnici.tipoVoltura = true;
              this.altriDatiTecnici.lettura = true;
            }

          } else {
            if (value == 'VT1' || value == 'VL1') {
              this.altriDatiTecnici.show = true;
              this.altriDatiTecnici.tipoVoltura = true;
              this.altriDatiTecnici.lettura = true;
            } else {
              this.altriDatiTecnici.show = false;
            }
            this.altriDatiTecnici.livelloTensione = false;
            this.altriDatiTecnici.tensione = false;
            this.altriDatiTecnici.potenzaImpegnata = false;
            this.altriDatiTecnici.potenzaDisponibile = false;
            this.altriDatiTecnici.volume = false;
            this.altriDatiTecnici.presenzaCliente = false;
            this.altriDatiTecnici.dataDecorrenza = false;
          }
        }
      })
    }

    // if(this.prodotto?.cod_tipo_fornitura_id == 'EE'){
    //   this.richiesteList[2].datiTecnici = true;
    //   this.richiesteList[2].disabled = false;
    // } else {
    //   this.richiesteList[2].datiTecnici = false;
    //   this.richiesteList[2].disabled = true;
    // }

    if (this.dataService.user == 3) {
      _group.get('richiesta')?.valueChanges.subscribe((richiesta: string) => {
        if (['VT1', 'VL1'].includes(richiesta)) {
          this.disableFirmaVolture = true;
          this.datiFirmaForm.get('modalitaFirma')?.patchValue('2');
        } else {
          this.disableFirmaVolture = false;
          this.datiFirmaForm?.get('modalitaFirma')?.patchValue('1');
        }
      })
    }

    if (this.prodotto?.cod_tipo_fornitura_id == 'EE') {
      _group.get('commodity')?.setValue('0', { emitEvent: false });
      (_group.get('pods') as UntypedFormArray).push(this.podGroup(_group));
    } else if (this.prodotto?.cod_tipo_fornitura_id == 'GAS') {
      _group.get('commodity')?.setValue('1', { emitEvent: false });
      (_group.get('pdrs') as UntypedFormArray).push(this.pdrGroup(_group));
    } else {
      _group.get('commodity')?.setValue('2', { emitEvent: false });
      (_group.get('pods') as UntypedFormArray).push(this.podGroup(_group));
      (_group.get('pdrs') as UntypedFormArray).push(this.pdrGroup(_group));
    }
    _group.get('commodity')?.disable();

    if (this.prodotto?.natura == 'TUTELA') {
      _group.get('richiesta')?.patchValue('AOF');
    } else {
      _group.get('richiesta')?.patchValue('SE1');
    }

    return _group;
  }

  podGroup(_richiestaGroup: UntypedFormGroup) {
    let _group = new UntypedFormGroup({
      datiTecnici: this.datiTecniciEEGroup(_richiestaGroup),
      indirizzoUguale: new UntypedFormControl(false),
      denominazione: new UntypedFormControl(''),
      indirizzo: new UntypedFormGroup({
        toponimo: new UntypedFormControl('', [Validators.required]),
        indirizzo: new UntypedFormControl('', [Validators.required]),
        civico: new UntypedFormControl('', [Validators.required]),
        comune: new UntypedFormControl('', [Validators.required]),
        cap: new UntypedFormControl('', [Validators.required]),
        provincia: new UntypedFormControl('', [Validators.required])
      }),
      checkIvaAgevolata: new UntypedFormControl(false),
      checkDatiCatastali: new UntypedFormControl('0'),
      datiCatastali: this.datiCatastaliGroup
    })

    _group.get('checkDatiCatastali')?.valueChanges.subscribe(value => {
      if (value == '0') {
        for (const control in (_group.get('datiCatastali') as UntypedFormGroup).controls) {
          (_group.get('datiCatastali') as UntypedFormGroup).controls[control].clearValidators();
          (_group.get('datiCatastali') as UntypedFormGroup).controls[control].updateValueAndValidity({ emitEvent: false });
        }
      } else {
        for (const control in (_group.get('datiCatastali') as UntypedFormGroup).controls) {
          if (control == 'codiceCatastale') {
            (_group.get('datiCatastali') as UntypedFormGroup).controls[control].addValidators([Validators.required, Validators.maxLength(4), Validators.pattern(/^[a-zA-Z][0-9]+$/)]);
          } else if (control == 'foglio' || control == 'particella' || control == 'subalterno') {
            (_group.get('datiCatastali') as UntypedFormGroup).controls[control].addValidators(Validators.required);
          }
          (_group.get('datiCatastali') as UntypedFormGroup).controls[control].updateValueAndValidity({ emitEvent: false });
        }
      }
    })

    if (this.tipoUtenza == 'DOM') {
      combineLatest([
        _group.get('datiTecnici')?.get('residente')?.valueChanges.pipe(
          map(value => { return value == '0' }),
        )!,
        // this.dataService.isCfStraniero$
        this.dataService.isIndirizzoEstero$
      ]).subscribe(([residente, indirizzoEstero]) => {
        _group.get('indirizzoUguale')?.disable();
        if (residente && !indirizzoEstero) {
          _group.get('indirizzoUguale')?.patchValue(true);
        } else {
          _group.get('indirizzoUguale')?.patchValue(false);
        }

      });

    } else {
      this.dataService.isCfStraniero$.subscribe(cf_straniero => {

        if (!cf_straniero) {
          _group.get('indirizzoUguale')?.enable();
        } else {
          _group.get('indirizzoUguale')?.patchValue(false);
          _group.get('indirizzoUguale')?.disable();
        }
      })

    }

    _group.get('indirizzoUguale')?.valueChanges.subscribe(value => {
      for (let control in (_group.get('indirizzo') as UntypedFormGroup).controls) {
        if (value) {
          _group.get('indirizzo')?.get(control)?.clearValidators();
          _group.get('indirizzo')?.get(control)?.disable();
          _group.get('denominazione')?.disable();
        } else {
          if (control == 'indirizzo') {
            _group.get('indirizzo')?.get(control)?.setValidators([Validators.required]);
          } else {
            _group.get('indirizzo')?.get(control)?.setValidators(Validators.required);
          }
          _group.get('indirizzo')?.get(control)?.enable();
          _group.get('denominazione')?.enable();
        }
      }

      this.handleDistributore(_group, 'EE', value);

    });

    _group.get('datiTecnici')?.get('residente')?.patchValue('0');

    _richiestaGroup.get('richiesta')?.valueChanges.subscribe(value => {
      if (this.altriDatiTecnici.distributoreEE) {
        _group.get('datiTecnici')?.get('distributore')?.addValidators([Validators.required]);
      } else {
        _group.get('datiTecnici')?.get('distributore')?.clearValidators();
        _group.get('datiTecnici')?.get('distributore')?.setValue(null, { emitEvent: false });
      }
      _group.get('datiTecnici')?.get('distributore')?.updateValueAndValidity();

      if (this.altriDatiTecnici.potenzaImpegnata) {
        _group.get('datiTecnici')?.get('potenzaImpegnata')?.addValidators([Validators.required]);
      } else {
        _group.get('datiTecnici')?.get('potenzaImpegnata')?.clearValidators();
        _group.get('datiTecnici')?.get('potenzaImpegnata')?.setValue(null, { emitEvent: false });
      }
      if (this.altriDatiTecnici.potenzaDisponibile) {
        _group.get('datiTecnici')?.get('potenzaDisponibile')?.addValidators([Validators.required]);
      } else {
        _group.get('datiTecnici')?.get('potenzaDisponibile')?.clearValidators();
        _group.get('datiTecnici')?.get('potenzaDisponibile')?.setValue(null, { emitEvent: false });
      }
      if (this.altriDatiTecnici.tensione) {
        _group.get('datiTecnici')?.get('tensione')?.addValidators([Validators.required]);
      } else {
        _group.get('datiTecnici')?.get('tensione')?.clearValidators();
        _group.get('datiTecnici')?.get('tensione')?.setValue(null, { emitEvent: false });
      }
      if (this.altriDatiTecnici.livelloTensione) {
        _group.get('datiTecnici')?.get('livelloTensione')?.setValidators([Validators.required]);
      } else {
        _group.get('datiTecnici')?.get('livelloTensione')?.clearValidators();
        _group.get('datiTecnici')?.get('livelloTensione')?.setValue(null, { emitEvent: false });
      }
      if (this.altriDatiTecnici.volume) {
        _group.get('datiTecnici')?.get('volume')?.setValidators([Validators.required, Validators.pattern(/^[0-9]+$/)]);
        // _group.get('datiTecnici')?.get('volume')?.setValue(this.dataService.volume_cerved, { emitEvent: false });
      } else {
        _group.get('datiTecnici')?.get('volume')?.clearValidators();
        _group.get('datiTecnici')?.get('volume')?.setValue(null, { emitEvent: false });
      }
      if (this.altriDatiTecnici.settoreMerceologico) {
        _group.get('datiTecnici')?.get('settoreMerceologico')?.setValidators([Validators.required]);
        if (this.datiAnaForm?.get('tipoCliente')?.value == '1') {
          _group.get('datiTecnici')?.get('settoreMerceologico')?.patchValue('97.00.02', { emitEvent: false });
        }
      } else {
        _group.get('datiTecnici')?.get('settoreMerceologico')?.clearValidators();
        _group.get('datiTecnici')?.get('settoreMerceologico')?.setValue(null, { emitEvent: false });
      }

      if (value == 'N02') {
        _group.get('datiTecnici')?.get('pod')?.patchValue('', { emitEvent: false });
        _group.get('datiTecnici')?.get('pod')?.disable();
      } else {
        _group.get('datiTecnici')?.get('pod')?.enable();
      }

      _group.get('datiTecnici')?.get('potenzaImpegnata')?.updateValueAndValidity({ emitEvent: false });
      _group.get('datiTecnici')?.get('potenzaDisponibile')?.updateValueAndValidity({ emitEvent: false });
      _group.get('datiTecnici')?.get('tensione')?.updateValueAndValidity({ emitEvent: false });

      this.handleDistributore(_group, 'EE', _group.get('indirizzoUguale')?.value);

    })


    return _group;
  }

  pdrGroup(_richiestaGroup: UntypedFormGroup) {
    let _group = new UntypedFormGroup({
      datiTecnici: this.datiTecniciGASGroup(_richiestaGroup),
      indirizzoUguale: new UntypedFormControl(false),
      denominazione: new UntypedFormControl(''),
      indirizzo: new UntypedFormGroup({
        toponimo: new UntypedFormControl('', [Validators.required]),
        indirizzo: new UntypedFormControl('', [Validators.required]),
        civico: new UntypedFormControl('', [Validators.required]),
        comune: new UntypedFormControl('', [Validators.required]),
        cap: new UntypedFormControl('', [Validators.required]),
        provincia: new UntypedFormControl('', [Validators.required])
      }),
      checkIvaAgevolata: new UntypedFormControl(false),
      checkDatiCatastali: new UntypedFormControl('0'),
      datiCatastali: this.datiCatastaliGroup
    })

    _group.get('checkDatiCatastali')?.valueChanges.subscribe(value => {
      if (value == '0') {
        for (const control in (_group.get('datiCatastali') as UntypedFormGroup).controls) {
          (_group.get('datiCatastali') as UntypedFormGroup).controls[control].clearValidators();
          (_group.get('datiCatastali') as UntypedFormGroup).controls[control].updateValueAndValidity({ emitEvent: false });
        }
      } else {
        for (const control in (_group.get('datiCatastali') as UntypedFormGroup).controls) {
          if (control == 'codiceCatastale') {
            (_group.get('datiCatastali') as UntypedFormGroup).controls[control].addValidators([Validators.required, Validators.maxLength(4), Validators.pattern(/^[a-zA-Z][0-9]+$/)]);
          } else if (control == 'foglio' || control == 'particella' || control == 'subalterno') {
            (_group.get('datiCatastali') as UntypedFormGroup).controls[control].addValidators(Validators.required);
          }
          (_group.get('datiCatastali') as UntypedFormGroup).controls[control].updateValueAndValidity({ emitEvent: false });
        }
      }
    })

    _group.get('indirizzoUguale')?.valueChanges.subscribe(value => {
      for (let control in (_group.get('indirizzo') as UntypedFormGroup).controls) {
        if (value) {
          _group.get('indirizzo')?.get(control)?.clearValidators();
          _group.get('indirizzo')?.get(control)?.disable();
        } else {
          if (control == 'indirizzo') {
            _group.get('indirizzo')?.get(control)?.setValidators([Validators.required]);
          } else {
            _group.get('indirizzo')?.get(control)?.setValidators(Validators.required);
          }
          _group.get('indirizzo')?.get(control)?.enable();
        }
      }

      this.handleDistributore(_group, 'GAS', value);

    });

    _richiestaGroup.get('richiesta')?.valueChanges.subscribe(value => {

      if (this.altriDatiTecnici.distributoreGAS) {
        _group.get('datiTecnici')?.get('distributore')?.addValidators([Validators.required]);
      } else {
        _group.get('datiTecnici')?.get('distributore')?.clearValidators();
        _group.get('datiTecnici')?.get('distributore')?.setValue(null, { emitEvent: false });
      }

      if (this.altriDatiTecnici.categoriaUso) {
        _group.get('datiTecnici')?.get('categoriaUso')?.addValidators([Validators.required]);
      } else {
        _group.get('datiTecnici')?.get('categoriaUso')?.clearValidators();
        _group.get('datiTecnici')?.get('categoriaUso')?.setValue(null, { emitEvent: false });
      }
      if (this.altriDatiTecnici.potenzaMassimaRichiesta) {
        _group.get('datiTecnici')?.get('potenzaMassimaRichiesta')?.setValidators([Validators.required, Validators.pattern(/^[0-9]+$/)]);
        if (this.prodotto?.tipo_utenza == 'DOM') {
          _group.get('datiTecnici')?.get('potenzaMassimaRichiesta')?.addValidators(Validators.max(56));
        }
      } else {
        _group.get('datiTecnici')?.get('potenzaMassimaRichiesta')?.clearValidators();
        _group.get('datiTecnici')?.get('potenzaMassimaRichiesta')?.setValue(null, { emitEvent: false });
      }
      if (this.altriDatiTecnici.consumoAnnuo) {
        _group.get('datiTecnici')?.get('consumoAnnuo')?.setValidators([Validators.required, Validators.pattern(/^[0-9]+$/)]);
        // _group.get('datiTecnici')?.get('consumoAnnuo')?.setValue(this.dataService.volume_cerved, { emitEvent: false });
      } else {
        _group.get('datiTecnici')?.get('consumoAnnuo')?.clearValidators();
        _group.get('datiTecnici')?.get('consumoAnnuo')?.setValue(null, { emitEvent: false });
      }
      if (this.altriDatiTecnici.tipoSubentro) {
        _group.get('datiTecnici')?.get('tipoSubentro')?.addValidators([Validators.required]);
      } else {
        _group.get('datiTecnici')?.get('tipoSubentro')?.clearValidators();
        _group.get('datiTecnici')?.get('tipoSubentro')?.setValue(null, { emitEvent: false });
      }
      if (this.altriDatiTecnici.settoreMerceologico) {
        _group.get('datiTecnici')?.get('settoreMerceologico')?.setValidators([Validators.required]);
        if (this.datiAnaForm?.get('tipoCliente')?.value == '1') {
          _group.get('datiTecnici')?.get('settoreMerceologico')?.patchValue('97.00.02', { emitEvent: false });
        }
      } else {
        _group.get('datiTecnici')?.get('settoreMerceologico')?.clearValidators();
        _group.get('datiTecnici')?.get('settoreMerceologico')?.setValue(null, { emitEvent: false });
      }

      if (value == 'N02') {
        _group.get('datiTecnici')?.get('pdr')?.patchValue('', { emitEvent: false });
        _group.get('datiTecnici')?.get('pdr')?.disable();
      } else {
        _group.get('datiTecnici')?.get('pdr')?.enable();
      }

      if (value == 'AOF') {
        _group.get('datiTecnici')?.get('dataDecorrenza')?.setValidators([Validators.required]);
      } else {
        _group.get('datiTecnici')?.get('dataDecorrenza')?.clearValidators();
      }
      _group.get('datiTecnici')?.get('dataDecorrenza')?.updateValueAndValidity();

      _group.get('datiTecnici')?.get('distributore')?.updateValueAndValidity();
      _group.get('datiTecnici')?.get('categoriaUso')?.updateValueAndValidity();
      _group.get('datiTecnici')?.get('consumoAnnuo')?.updateValueAndValidity();
      _group.get('datiTecnici')?.get('tipoSubentro')?.updateValueAndValidity();
      _group.get('datiTecnici')?.get('potenzaMassimaRichiesta')?.updateValueAndValidity();


      this.handleDistributore(_group, 'GAS', _group.get('indirizzoUguale')?.value);

    });

    return _group;
  }

  get datiCatastaliGroup() {
    let _group = new UntypedFormGroup({
      foglio: new UntypedFormControl(''),
      sezione: new UntypedFormControl(''),
      estensione: new UntypedFormControl(''),
      particella: new UntypedFormControl(''),
      subalterno: new UntypedFormControl(''),
      codiceUnita: new UntypedFormControl(''),
      assenzaDati: new UntypedFormControl(''),
      codiceCatastale: new UntypedFormControl(''),
      codiceQualifica: new UntypedFormControl(''),
      codiceParticella: new UntypedFormControl(''),
    })

    _group.get('assenzaDati')?.valueChanges.subscribe(value => {
      if (value != '') {
        for (let control in _group.controls) {
          switch (control) {
            case 'assenzaDati':
              continue;
            default:
              _group.get(control)?.disable({ emitEvent: false });
              _group.get(control)?.removeValidators(Validators.required);
          }
          _group.get(control)?.updateValueAndValidity({ emitEvent: false });
        }
      } else {
        for (let control in _group.controls) {

          if (control == 'codiceCatastale') {
            _group.controls[control].addValidators([Validators.required, Validators.maxLength(4), Validators.pattern(/^[a-zA-Z][0-9]+$/)]);
          } else if (control == 'foglio' || control == 'particella' || control == 'subalterno') {
            _group.controls[control].addValidators(Validators.required);
          } else if (control == 'assenzaDati') { }
          _group.get(control)?.enable({ emitEvent: false });
          // _group.get(control)?.updateValueAndValidity({ emitEvent: false });
        }
      }
    })

    _group.valueChanges.subscribe(value => {
      if (
        value.foglio ||
        value.sezione ||
        value.estensione ||
        value.particella ||
        value.subalterno ||
        value.codiceUnita ||
        value.codiceCatastale ||
        value.codiceQualifica ||
        value.codiceParticella
      ) {
        _group.get('assenzaDati')?.disable({ emitEvent: false });
      } else {
        _group.get('assenzaDati')?.enable({ emitEvent: false });
      }
    });
    return _group;
  }

  get startOfMonth() {
    return moment().startOf('month');
  }

  get minDecorr() {
    let _data = moment();
    if (_data.date() < 10) {
      return moment().add(1, 'months').startOf('month');
    } else {
      return moment().add(2, 'months').startOf('month');
    }
  }

  minFineForn = moment();

  dateFilter: (date: Moment | null) => boolean =
    (date: Moment | null) => {
      if (date) {
        const day = date.date();
        const endOfMonth = date.endOf('month').date();
        return day == endOfMonth;
      } else { return false }
    }
  startMonthDateFilter: (date: Moment | null) => boolean =
    (date: Moment | null) => {
      if (date) {
        const day = date.date();
        const startOfMonth = date.startOf('month').date();
        return day == startOfMonth;
      } else { return false }
    }
  datiTecniciEEGroup(_richiestaGroup: UntypedFormGroup) {

    let _group = new UntypedFormGroup({
      pod: new UntypedFormControl('', [Validators.required, Validators.minLength(14), Validators.maxLength(14), Validators.pattern(/^IT[0-9]+E[0-9]+([A-A]{1})?$/)]), // ^IT[0-9]+E[0-9]+[A-Z0-9]{1}$
      residente: new UntypedFormControl(null, [Validators.required]),
      livelloTensione: new UntypedFormControl(null),
      volume: new UntypedFormControl(null),
      dataDecorrenza: new UntypedFormControl(null),
      tensione: new UntypedFormControl(null),
      potenzaImpegnata: new UntypedFormControl(null),
      potenzaDisponibile: new UntypedFormControl({ value: null, disabled: true }, [Validators.pattern(/^[0-9]+$/)]),
      presenzaCliente: new UntypedFormControl('0'),
      distributore: new UntypedFormControl({ value: null, disabled: true }),
      ctrTempoDeterminato: new UntypedFormControl(),
      dataFineFornitura: new UntypedFormControl(),
      settoreMerceologico: new UntypedFormControl(null)
    })

    // _group.valueChanges.subscribe(v => {
    //   console.log(_group?.errors, v);
    // })

    // setTimeout(() => {
    //   _group.get('residente')?.patchValue('0', { emitEvent: true });
    // }, 3000);
    // _group.get('residente')?.updateValueAndValidity();

    // if (this.tipoUtenza == 'BUS') {
    //   _group.get('livelloTensione')?.setValidators([Validators.required]);
    //   _group.get('livelloTensione')?.updateValueAndValidity();
    //   _group.get('volume')?.setValidators([Validators.required, Validators.pattern(/^[0-9]+$/)]);
    //   _group.get('volume')?.updateValueAndValidity();
    // }
    _group.get('ctrTempoDeterminato')?.valueChanges.subscribe(value => {
      if (value == '1') {
        this.minFineForn = moment().endOf('month');
        _group.get('dataFineFornitura')?.enable();
        _group.get('dataFineFornitura')?.patchValue(this.minFineForn);
      } else {
        this.minFineForn = moment();
        _group.get('dataFineFornitura')?.disable();
        _group.get('dataFineFornitura')?.patchValue(null);
      }
    })


    _group.get('potenzaImpegnata')?.valueChanges.subscribe(value => {
      if (value == 'Altra potenza') {
        _group.get('potenzaDisponibile')?.enable();
        _group.get('potenzaDisponibile')?.patchValue('');
      } else {
        _group.get('potenzaDisponibile')?.disable();
        // _group.get('potenzaDisponibile')?.patchValue((parseFloat(_group.get('potenzaImpegnata')?.value.replace(',', '.')) * 1.1).toFixed(2));
      }

    })

    // if(this.dataService.user == 3){
    _group.get('pod')?.addAsyncValidators(this.bwAsyncValidator.checkPdp(_richiestaGroup));
    // }

    // _group.get('pod')?.valueChanges.subscribe(value => {
    //   if(_group.get('pod')?.valid){
    //     this.httpService.checkPdp(value).subscribe(
    //       res => {
    //         if (res.esiste && _richiestaGroup.get('richiesta')?.value == 'SE1'){
    //           this.snackbar.open('Attenzione, modificare la richiesta da "Cambio Fornitore" a "Cambio Prodotto"', undefined, { panelClass: ['snack-error'], duration: 4000 });
    //         } else if (!res.esiste && _richiestaGroup.get('richiesta')?.value == 'AOF'){
    //           this.snackbar.open('Attenzione, modificare la richiesta da "Cambio Prodotto" a "Cambio Fornitore"', undefined, { panelClass: ['snack-error'], duration: 4000 });
    //         }
    //     }, err => {

    //     })
    //   }
    // })

    _group.get('ctrTempoDeterminato')?.patchValue('0');

    if (this.dataService?.volume_cerved) {
      _group.get('volume')?.patchValue(this.dataService?.volume_cerved);
      // _group.get('volume')?.disable();
    }

    _richiestaGroup.get('richiesta')?.valueChanges.subscribe(richiesta => {
      if (richiesta == 'VT1' || richiesta == 'VL1') {
        _group.addControl('tipoVoltura', new UntypedFormControl('', [Validators.required]));
      } else {
        _group.removeControl('tipoVoltura');
      }
    })


    return _group;
  }

  private setValidityDatiTecnici(_group?: any) {
    if (this.dataService.user == 3 && _group && this.prodotto?.tipo_utenza == 'BUS') {
      this.datiAnaForm?.get('tipoCliente')?.valueChanges.subscribe(tipo => {
        if (tipo == '0') {
          _group.get('ctrTempoDeterminato')?.addValidators(Validators.required);
          _group.get('dataFineFornitura')?.addValidators(Validators.required);
          this.altriDatiTecnici.dataFineFornitura = true;
          this.altriDatiTecnici.ctrTempoDeterminato = true;
        } else {
          _group.get('ctrTempoDeterminato')?.clearValidators();
          _group.get('dataFineFornitura')?.clearValidators();
          this.altriDatiTecnici.dataFineFornitura = false;
          this.altriDatiTecnici.ctrTempoDeterminato = false;
        }
        _group.get('ctrTempoDeterminato')?.updateValueAndValidity();
        _group.get('dataFineFornitura')?.updateValueAndValidity();

      });
    }
  }

  // funzione che cicla gli array di pods e pdr e applica i validators
  private bindAnaForm() {
    if (this.datiAnaForm) {
      this.richieste.controls.forEach(richiestaGroup => {
        this.pods(richiestaGroup).controls.forEach(podGroup => {
          this.setValidityDatiTecnici(podGroup.get('datiTecnici'));
        })
        this.pdrs(richiestaGroup).controls.forEach(pdrGroup => {
          this.setValidityDatiTecnici(pdrGroup.get('datiTecnici'));
        })
      })
    }
  }

  datiTecniciGASGroup(_richiestaGroup: UntypedFormGroup) {
    let _group = new UntypedFormGroup({
      pdr: new UntypedFormControl(null, [Validators.required, Validators.minLength(14), Validators.maxLength(14), Validators.pattern(/^[0-9]+$/)]),
      distributore: new UntypedFormControl({ value: null, disabled: true }),
      consumoAnnuo: new UntypedFormControl(null),
      dataDecorrenza: new UntypedFormControl(null),
      categoriaUso: new UntypedFormControl(null),
      potenzaMassimaRichiesta: new UntypedFormControl(null),
      tipoSubentro: new UntypedFormControl('0'),
      ctrTempoDeterminato: new UntypedFormControl('0'),
      dataFineFornitura: new UntypedFormControl(this.minFineForn),
      settoreMerceologico: new UntypedFormControl(null)
    })

    // if (this.tipoUtenza == 'BUS') {
    //   _group.get('consumoAnnuo')?.setValue(2000, { emitEvent: false });
    // } else {
    //   _group.get('consumoAnnuo')?.setValue(1000, { emitEvent: false });
    // }

    // if (this.tipoUtenza == 'BUS') {
    //   _group.get('consumoAnnuo')?.setValidators([Validators.required, Validators.pattern(/^[0-9]+$/)]);
    //   _group.get('consumoAnnuo')?.updateValueAndValidity();
    //   _group.get('categoriaUso')?.setValidators([Validators.required]);
    //   _group.get('categoriaUso')?.updateValueAndValidity();
    // }

    _group.get('ctrTempoDeterminato')?.valueChanges.subscribe(value => {
      if (value == '1') {
        this.minFineForn = moment().add(1, 'y').endOf('month');
        _group.get('dataFineFornitura')?.enable();
      } else {
        this.minFineForn = moment().add(1, 'y');
        _group.get('dataFineFornitura')?.disable();
      }
      _group.get('dataFineFornitura')?.patchValue(this.minFineForn);
    })

    _group.get('pdr')?.addAsyncValidators(this.bwAsyncValidator.checkPdp(_richiestaGroup));

    if (this.dataService?.volume_cerved) {
      _group.get('consumoAnnuo')?.patchValue(this.dataService?.volume_cerved);
      // _group.get('consumoAnnuo')?.disable();
    }

    _richiestaGroup.get('richiesta')?.valueChanges.subscribe(richiesta => {
      if (richiesta == 'VT1' || richiesta == 'VL1') {
        _group.addControl('tipoVoltura', new UntypedFormControl('', [Validators.required]));
      } else {
        _group.removeControl('tipoVoltura');
      }

      if (richiesta == 'VT1' || richiesta == 'VL1') {
        _group.addControl('lettura', new UntypedFormGroup({
          valore: new UntypedFormControl('', [Validators.pattern(/^[0-9]+$/)]),
          data: new UntypedFormControl('')
        }));
      }

    })


    return _group;
  }

  handleDistributore(_group: UntypedFormGroup, _tipoForn: string, indirizzoUguale: boolean) {
    // scarica lista dei distributori in base al comune in dati anagrafici
    if (_tipoForn == 'EE' && this.altriDatiTecnici.distributoreEE) {
      if (indirizzoUguale) {
        this.distributoriEE$ = this.httpService.get('getDistributori', { idComune: this.datiAnaForm.get('indirizzo')?.get('comune')?.value, fornitura: _tipoForn }).subscribe(response => {
          this.distributoriEE = response;
          if (!response.some((distributore: any) => distributore.id_distributore_id === _group.get('datiTecnici')?.get('distributore')?.value)) {
            _group.get('datiTecnici')?.get('distributore')?.patchValue(null, { eventEmit: false });
          }
          _group.get('datiTecnici')?.get('distributore')?.enable();
        });
      } else {
        // controllo che comune abbia un valore e che distributori sia undefined
        if (_group.get('indirizzo')?.get('comune')?.value && !!this.distributoriEE) {
          // setto distributori undefined cosi da non innescare doppie chiamate al backend
          this.distributoriEE = undefined;
          this.distributoriEE$ = this.httpService.get('getDistributori', { idComune: _group.get('indirizzo')?.get('comune')?.value, fornitura: _tipoForn }).subscribe(response => {
            this.distributoriEE = response;
            _group.get('datiTecnici')?.get('distributore')?.patchValue(null, { eventEmit: false });
            _group.get('datiTecnici')?.get('distributore')?.enable();
          });

        } else {
          _group.get('datiTecnici')?.get('distributore')?.patchValue(null, { eventEmit: false });
          _group.get('datiTecnici')?.get('distributore')?.disable();
        }
      }
    } else if (_tipoForn == 'GAS' && this.altriDatiTecnici.distributoreGAS) {
      if (indirizzoUguale) {
        this.httpService.get('getDistributori', { idComune: this.datiAnaForm.get('indirizzo')?.get('comune')?.value, fornitura: _tipoForn }).subscribe(response => {
          this.distributoriGAS = response;
          _group.get('datiTecnici')?.get('distributore')?.patchValue(null, { eventEmit: false });
          _group.get('datiTecnici')?.get('distributore')?.enable();
        });
      } else {
        // controllo che comune abbia un valore e che distributori sia undefined
        if (_group.get('indirizzo')?.get('comune')?.value && !!this.distributoriGAS) {
          // setto distributori undefined cosi da non innescare doppie chiamate al backend
          this.distributoriGAS = undefined;
          this.httpService.get('getDistributori', { idComune: _group.get('indirizzo')?.get('comune')?.value, fornitura: _tipoForn }).subscribe(response => {
            this.distributoriGAS = response;
            _group.get('datiTecnici')?.get('distributore')?.patchValue(null, { eventEmit: false });
            _group.get('datiTecnici')?.get('distributore')?.enable();
          });

        } else {
          _group.get('datiTecnici')?.get('distributore')?.patchValue(null, { eventEmit: false });
          _group.get('datiTecnici')?.get('distributore')?.disable();
        }
      }
    }

    // gestione del cambio comune nell'indirizzo
    _group.get('indirizzo')?.get('comune')?.valueChanges.subscribe(value => {
      if (_tipoForn == 'EE' && this.altriDatiTecnici.distributoreEE) {
        // controllo che il comune abbia un valore, che sia diverso dal precedente e che distributori sia undefined
        if (!!_group.get('indirizzo')?.get('comune')?.value && _group.get('indirizzo')?.get('comune')?.value != _group.get('indirizzo')?.value.comune && !!this.distributoriEE) {
          // setto distributori undefined cosi da non innescare doppie chiamate al backend
          this.distributoriEE = undefined;
          this.httpService.get('getDistributori', { idComune: value, fornitura: _tipoForn }).subscribe(response => {
            this.distributoriEE = response;
            _group.get('datiTecnici')?.get('distributore')?.patchValue(null, { eventEmit: false });
            _group.get('datiTecnici')?.get('distributore')?.enable();
          });
        }
      } else if (_tipoForn == 'GAS' && this.altriDatiTecnici.distributoreGAS) {
        // controllo che il comune abbia un valore, che sia diverso dal precedente e che distributori sia undefined
        if (!!_group.get('indirizzo')?.get('comune')?.value && _group.get('indirizzo')?.get('comune')?.value != _group.get('indirizzo')?.value.comune && !!this.distributoriGAS) {
          // setto distributori undefined cosi da non innescare doppie chiamate al backend
          this.distributoriGAS = undefined;
          this.httpService.get('getDistributori', { idComune: value, fornitura: _tipoForn }).subscribe(response => {
            this.distributoriGAS = response;
            _group.get('datiTecnici')?.get('distributore')?.patchValue(null, { eventEmit: false });
            _group.get('datiTecnici')?.get('distributore')?.enable();
          });
        }
      }
    })

  }

  constructor(
    private fb: FormBuilder,
    public dataService: DataService,
    private httpService: ApiHttpService,
    private bwAsyncValidator: BWAsyncValidator,
  ) {
    this.datiFornForm = this.fb.group({
      richieste: new UntypedFormArray([])
    });

    // (this.datiFornForm.get('richieste') as UntypedFormArray).push(this.richiestaGroup);

    this.richieste.valueChanges.subscribe(_ => this.bindAnaForm());

    this.addRichiesta();
  }

  ngOnInit(): void {

    this.bindAnaForm();

    // debug
    // this.datiFornForm.valueChanges.subscribe(_ => {
    //   debugForm(this.datiFornForm.controls);
    // })

    richiesteList.map((r) => {
      if (this.prodotto?.cod_tipo_fornitura_id == 'GAS' || this.prodotto?.cod_tipo_fornitura_id == 'EE/GAS') {
        if (r.code == 'A01') {
          r.show = false;
        } else if (r.code == 'N02') {
          // r.disabled = false;
          r.show = false;
        }
      }

      if (this.dataService.user == 2) {
        if (r.code == 'SE1') {
          r.show = true;
        } else if (r.code == 'AOF') {
          r.disabled = true;
        }
        else {
          r.show = false;
        }
      }
    })


    if (this.dataService.ctr_data) {
      setTimeout(() => {
        let ctr_data = this.dataService.ctr_data;

        let pdps: any;
        if (this.prodotto?.cod_tipo_fornitura_id == 'EE') {
          pdps = ctr_data.datiFornitura[0].pods;
          delete ctr_data.datiFornitura[0].pods;
        } else if (this.prodotto?.cod_tipo_fornitura_id == 'GAS') {
          pdps = ctr_data.datiFornitura[0].pdrs;
          delete ctr_data.datiFornitura[0].pdrs;
        }

        this.datiFornForm.get('richieste')!.patchValue(ctr_data.datiFornitura);

        pdps.forEach((pdp: any, index: number) => {
          let pdp_richiesta: any;

          if (this.prodotto?.cod_tipo_fornitura_id == 'EE') {
            pdp_richiesta = (this.richieste.at(0).get('pods') as UntypedFormArray).at(index) as FormGroup;
          } else if (this.prodotto?.cod_tipo_fornitura_id == 'GAS') {
            pdp_richiesta = (this.richieste.at(0).get('pdrs') as UntypedFormArray).at(index) as FormGroup;
          }

          let datiTecnici = pdp.datiTecnici;
          delete pdp.datiTecnici;

          if (pdp.datiCatastali.assenzaDati != '' || pdp.checkDatiCatastali == '0') {
            delete pdp.datiCatastali;
          }

          if (datiTecnici.dataDecorrenza) {
            datiTecnici.dataDecorrenza = moment(datiTecnici.dataDecorrenza, 'DD/MM/YYYY');
          }

          pdp_richiesta.patchValue(pdp);
          if (this.prodotto?.cod_tipo_fornitura_id == 'EE') {
            if (this.distributoriEE$) {
              this.distributoriEE$?.add(() => {
                pdp_richiesta.get('datiTecnici')?.patchValue(datiTecnici, { emitEvent: false });
              })
            } else {
              pdp_richiesta.get('datiTecnici')?.patchValue(datiTecnici, { emitEvent: false });
            }
          } else if (this.prodotto?.cod_tipo_fornitura_id == 'GAS') {
            if (this.distributoriGAS$) {
              this.distributoriGAS$?.add(() => {
                pdp_richiesta.get('datiTecnici')?.patchValue(datiTecnici, { emitEvent: false });
              })
            } else {
              pdp_richiesta.get('datiTecnici')?.patchValue(datiTecnici, { emitEvent: false });
            }
          }
        });
      }, 2000);
    }


    this.distributoriEE = [];
    this.distributoriGAS = [];

    moment.locale('it');

  }

  addPod(richiesta: any) {
    (richiesta.get('pods') as UntypedFormArray).push(this.podGroup(richiesta));
  }

  addPdr(richiesta: any) {
    (richiesta.get('pdrs') as UntypedFormArray).push(this.pdrGroup(richiesta));
  }

  addRichiesta() {
    (this.datiFornForm.get('richieste') as UntypedFormArray).push(this.richiestaGroup);
  }

  removePod(id: number, richiesta: any) {
    (richiesta.get('pods') as UntypedFormArray).removeAt(id);
  }

  removePdr(id: number, richiesta: any) {
    (richiesta.get('pdrs') as UntypedFormArray).removeAt(id);
  }

  removeRichiesta(id: number) {
    (this.datiFornForm.get('richieste') as UntypedFormArray).removeAt(id);
  }

  downloadDocCompilato() {
    this.httpService.downloadDocCompilato(this.dataService.doc_iva_agevolata!, this.datiAnaForm.getRawValue(), 'Iva agevolata - ALLEGATO_G');
  }

}
